<template lang="pug">
  div.classifier.fkko-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs()
      slot
        e-form(:formValidator="formValidator")
          div(v-if="isRegional === true")
            div.body
              div.col
                e-form-group(
                  inputType="suggestion"
                  name="parentIdName"
                  label="Наименование группы отходов"
                  :model="fields"
                  :required="true"
                  :userInnerSearch="true"
                  :options="fkkoChilds"
                  realName="parent_id"
                  tabView="tab1"
                )
                e-form-group(
                name="danger"
                inputType="select"
                label="Класс опасности"
                  :model="fields"
                    :required="true"
                 validationRule="number"
                tabView="tab1"
                :options="dangerOptions"
                )
                e-form-group(
                name="_computedCode"
                inputType="input"
                label="Полученнный код регионального ФККО"
                  :model="fields"
                    :disabled="true"
                tabView="tab1"
                )
                e-form-group(
                name="name"
                inputType="input"
                label="Наименование отхода"
                  :model="fields"
                  :disabled="true"
                tabView="tab1"
                )

              div.col
                e-form-group(
                name="production"
                inputType="input"
                label="Производство"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="tech_process"
                inputType="input"
                label="Технологический процесс"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="fkko_state_id"
                inputType="select"
                label="Агрегатное состояние"
                  :model="fields"
                tabView="tab1"
                :options="states"
                )
                e-form-group(
                name="composition"
                inputType="input"
                label="Состав"
                  :model="fields"
                tabView="tab1"
                )

              div.col
                div.col-block.waste-types
                  label Типы отходов:
                  e-form-group(
                  name="is_tko"
                    :model="fields"
                  tabView="tab1"
                  caption="ТКО"
                  inputType="checkbox"
                  )
                  e-form-group(
                  name="is_rso"
                    :model="fields"
                  tabView="tab1"
                  caption="Ртутьсодержащий отход"
                  inputType="checkbox"
                  )
                  e-form-group(
                  name="is_battery"
                    :model="fields"
                  tabView="tab1"
                  caption="Элемент питания"
                  inputType="checkbox"
                  )
                  e-form-group(
                    name="is_bio"
                    :model="fields"
                    tabView="tab1"
                    caption="Биологический отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_production"
                    :model="fields"
                    tabView="tab1"
                    caption="Производственный отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_build"
                    :model="fields"
                    tabView="tab1"
                    caption="Строительный отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_liquid"
                    :model="fields"
                    tabView="tab1"
                    caption="Жидкий бытовой отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_med"
                    :model="fields"
                    tabView="tab1"
                    caption="Медицинский отход"
                    inputType="checkbox"
                  )
                div.col-block.waste-cats
                  label Категория отхода
                  e-form-group(
                    name="is_fkko"
                    :model="fields"
                    tabView="tab1"
                    caption="Включен в ФККО"
                    inputType="checkbox"
                  )

          div(v-else-if="isNoGroup === true")
            div.body
              div.col
                e-form-group(
                inputType="suggestion"
                name="parentIdName"
                label="Наименование группы отходов"
                  :model="fields"
                    :required="true"
                    :userInnerSearch="true"
                    :options="fkkoChilds"
                realName="parent_id"
                tabView="tab1"
                  :disabled="true"
                )
                e-form-group(
                name="danger"
                inputType="select"
                label="Класс опасности"
                  :model="fields"
                    :required="true"
                validationRule="number"
                tabView="tab1"
                  :options="dangerOptions"
                    :disabled="true"
                )
                e-form-group(
                name="_computedCode"
                inputType="input"
                label="Полученнный код регионального ФККО"
                  :model="fields"
                    :disabled="true"
                tabView="tab1"
                )
                e-form-group(
                name="name"
                inputType="input"
                label="Наименование отхода"
                  :model="fields"
                    :disabled="true"
                tabView="tab1"
                )

              div.col
                e-form-group(
                name="production"
                inputType="input"
                label="Производство"
                  :model="fields"
                tabView="tab1"
                  :disabled="true"
                )
                e-form-group(
                name="tech_process"
                inputType="input"
                label="Технологический процесс"
                  :model="fields"
                tabView="tab1"
                  :disabled="true"
                )
                e-form-group(
                name="fkko_state_id"
                inputType="select"
                label="Агрегатное состояние"
                  :model="fields"
                tabView="tab1"
                  :options="states"
                    :disabled="true"
                )
                e-form-group(
                name="composition"
                inputType="input"
                label="Состав"
                  :model="fields"
                tabView="tab1"
                  :disabled="true"
                )

              div.col
                div.col-block.waste-types
                  label Типы отходов:
                  e-form-group(
                  name="is_tko"
                    :model="fields"
                  tabView="tab1"
                  caption="ТКО"
                  inputType="checkbox"
                  )
                  e-form-group(
                  name="is_rso"
                    :model="fields"
                  tabView="tab1"
                  caption="Ртутьсодержащий отход"
                  inputType="checkbox"
                  )
                  e-form-group(
                  name="is_battery"
                    :model="fields"
                  tabView="tab1"
                  caption="Элемент питания"
                  inputType="checkbox"
                  )
                  e-form-group(
                    name="is_bio"
                    :model="fields"
                    tabView="tab1"
                    caption="Биологический отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_production"
                    :model="fields"
                    tabView="tab1"
                    caption="Производственный отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_build"
                    :model="fields"
                    tabView="tab1"
                    caption="Строительный отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_liquid"
                    :model="fields"
                    tabView="tab1"
                    caption="Жидкий бытовой отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_med"
                    :model="fields"
                    tabView="tab1"
                    caption="Медицинский отход"
                    inputType="checkbox"
                  )
                div.col-block.waste-cats
                  label Категория отхода
                  e-form-group(
                    name="is_fkko"
                    :model="fields"
                    tabView="tab1"
                    caption="Включен в ФККО"
                    inputType="checkbox"
                  )

          div(v-else)
            div.body
              div.col
                e-form-group(
                v-if="groupRequired"
                inputType="suggestion"
                name="parentIdName"
                label="Наименование группы отходов"
                  :model="fields"
                    :required="true"
                    :userInnerSearch="true"
                    :options="fkkoChilds"
                realName="parent_id"
                tabView="tab1"
                :disabled="true"
                )
                e-form-group(
                v-else
                inputType="suggestion"
                name="parentIdName"
                label="Наименование группы отхода"
                  :model="fields"
                    :required="true"
                    :userInnerSearch="true"
                    :options="fkkoChilds"
                realName="id"
                tabView="tab1"
                  :disabled="true"
                )

                e-form-group(
                name="code"
                inputType="input"
                label="Код группы отходы"
                  :model="fields"
                    :disabled="true"
                tabView="tab1"
                )
                div.col-block.waste-types
                  label Типы отходов:
                  e-form-group(
                  name="is_tko"
                    :model="fields"
                  tabView="tab1"
                  caption="ТКО"
                  inputType="checkbox"
                  )
                  e-form-group(
                  name="is_rso"
                    :model="fields"
                  tabView="tab1"
                  caption="Ртутьсодержащий отход"
                  inputType="checkbox"
                  )
                  e-form-group(
                  name="is_battery"
                    :model="fields"
                  tabView="tab1"
                  caption="Элемент питания"
                  inputType="checkbox"
                  )
                  e-form-group(
                    name="is_bio"
                    :model="fields"
                    tabView="tab1"
                    caption="Биологический отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_production"
                    :model="fields"
                    tabView="tab1"
                    caption="Производственный отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_build"
                    :model="fields"
                    tabView="tab1"
                    caption="Строительный отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_liquid"
                    :model="fields"
                    tabView="tab1"
                    caption="Жидкий бытовой отход"
                    inputType="checkbox"
                  )
                  e-form-group(
                    name="is_med"
                    :model="fields"
                    tabView="tab1"
                    caption="Медицинский отход"
                    inputType="checkbox"
                  )
                div.col-block.waste-cats
                  label Категория отхода
                  e-form-group(
                    name="is_fkko"
                    :model="fields"
                    tabView="tab1"
                    caption="Включен в ФККО"
                    inputType="checkbox"
                  )

              div.col
              div.col
</template>

<style lang="scss">
  .fkko-update {
    .waste-types, .waste-cats {
      .col-block {
        margin: 0;
        padding: 0;

        label {
          // margin-bottom: 0;
        }
      }
    }
  }
</style>
<script>
  import {cadastr} from '../../api/api-endpoints.js'
  import fkkoForm from './mixins/fkko-form.js'

  export default {
    mixins: [fkkoForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          code: '',
          _computedCode: '',
          danger: '',
          parent_id: '',
          name: '',
          parentIdName: ''
        },

        errors: null
      }
    },
    methods: {
      getUpdateOrCreateUrl () {
        return cadastr.fkkoUpdate(this.$route.params.id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return cadastr.fkkoView(route.params.id)
      },
      getItemState () {
        return cadastr.fkkoState()
      },
      getFkkoChilds (route) {
        return cadastr.fkko({query:{parent_id: route.params.pid}})
      },
      getDeleteUrl (id) {
        return cadastr.fkkoDelete(id)
      }
    }
  }
</script>
